/*
Dependencies :
npm install react react-dom
npm install --save redux
npm install --save react-redux
npm install axios
npm i --save @fortawesome/fontawesome-svg-core
npm i --save @fortawesome/free-solid-svg-icons
npm i --save @fortawesome/react-fontawesome
npm install --save react-router-dom
npm install --save redux-thunk
npm install js-file-download --save
npm install react-apexcharts apexcharts
*/


import React from 'react';
import ReactDOM from 'react-dom';
import './Style/Components/AppTemplate.css';
import './Style/Components/HeaderComponents.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as serviceWorker from './serviceWorker';
import apiReducer from './Store/Reducers/apiReducer';
import appReducer from './Store/Reducers/appReducer';
import globalReducer from './Store/Reducers/globalReducer';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { combineReducers } from 'redux'
import thunk from 'redux-thunk';
import App from './Application/Components/App'


const combinedReducer = combineReducers({apiReducer,appReducer,globalReducer}); //  combineReducers({apiReducer, messagingReducer}); for EXAMPLE
const store = createStore(combinedReducer, applyMiddleware(thunk));
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>
  , document.getElementById('root'));

serviceWorker.unregister();